export const GLOBALS = {
  ENV:  "staging",
  URL: "https://ops.cinesendstaging.com",
  API_URL: "https://api.cinesendstaging.com/api",
  ACCOUNT_REDIRECT_URL: "https://accounts.cinesendstaging.com/login",
  CHROME_CAST_STYLESHEET_URL: "https://s3.amazonaws.com/bitmovin-cast-css/development/styles.min.css",
  S3_PUBLIC: "https://public-assets.cinesendstaging.com",
  S3_ACCELERATE_ENDPOINT: "https://cinesendcontainer-beta.s3-accelerate.amazonaws.com",
  BITMOVIN_API_KEY: "2a8b1f24-2c3c-4ab1-adeb-2b89af5171f0",
}